import { AutomationTrigger } from '@business/entities/automation';
import { NodeProps, useReactFlow } from 'reactflow';

import { AutomationNodeType } from '../NodeTypes';

export function useTriggerChange(id: NodeProps['id']) {
  const { setNodes, setEdges } = useReactFlow();

  const onClick = (trigger: AutomationTrigger) => {
    setNodes(nodes =>
      nodes.map(node => {
        if (node.id === id) {
          return {
            ...node,
            type: AutomationNodeType.trigger,
            data: trigger,
          };
        }
        return node;
      }),
    );

    setEdges(edges =>
      edges.map(edge => {
        if (edge.source === id) {
          return {
            ...edge,
            type: 'workflow',
          };
        }
        return edge;
      }),
    );
  };

  return onClick;
}

export default useTriggerChange;
